import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/admin-v2/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        authenticated: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(/* webpackChunkName: "Login" */ './views/Login.vue')
    },
    {
      path: '/registrations/:eventid',
      name: 'ManageRegistrations',
      component: () =>
        import(
          /* webpackChunkName: "ManageRegistrations" */ './views/ManageRegistrations.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/waitinglist/:eventid',
      name: 'ManageWaitingList',
      component: () =>
        import(
          /* webpackChunkName: "ManageWaitingList" */ './views/ManageWaitingList.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/leaderboard/:eventid',
      name: 'ManageLeaderboard',
      component: () =>
        import(
          /* webpackChunkName: "ManageLeaderboard" */ './views/ManageLeaderboard.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/spectators/:eventid',
      name: 'ManageSpectators',
      component: () =>
        import(
          /* webpackChunkName: "ManageSpectators" */ './views/ManageSpectators.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/judges/:eventid',
      name: 'ManageJudges',
      component: () =>
        import(
          /* webpackChunkName: "ManageJudges" */ './views/ManageJudges.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/volunteers/:eventid',
      name: 'ManageVolunteers',
      component: () =>
        import(
          /* webpackChunkName: "ManageVolunteers" */ './views/ManageVolunteers.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/vendors/:eventid',
      name: 'ManageVendors',
      component: () =>
        import(
          /* webpackChunkName: "ManageVendors" */ './views/ManageVendors.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/schedule/:eventid',
      name: 'ManageSchedule',
      component: () =>
        import(
          /* webpackChunkName: "ManageSchedule" */ './views/ManageSchedule.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/divisions/:eventid',
      name: 'ManageDivisions',
      component: () =>
        import(
          /* webpackChunkName: "ManageDivisions" */ './views/ManageDivisions.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/divisions/:eventid/:id',
      name: 'EditDivision',
      component: () =>
        import(
          /* webpackChunkName: "EditDivision" */ './views/EditDivision.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/workout/:eventid/:divisionid',
      name: 'CreateWorkout',
      component: () =>
        import(/* webpackChunkName: "EditWorkout" */ './views/EditWorkout.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/workout/:eventid/:divisionid/:id',
      name: 'EditWorkout',
      component: () =>
        import(/* webpackChunkName: "EditWorkout" */ './views/EditWorkout.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/capture-score/:eventid/:divisionid/:id',
      name: 'CaptureScore',
      component: () =>
        import(
          /* webpackChunkName: "CaptureScore" */ './views/CaptureScore.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/review-score/:eventid/:divisionid/:id',
      name: 'ReviewScore',
      component: () =>
        import(
          /* webpackChunkName: "CaptureScore" */ './views/CaptureScore.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/heats/:eventid/:divisionid/:id',
      name: 'ManageHeats',
      component: () =>
        import(/* webpackChunkName: "ManageHeats" */ './views/ManageHeats.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/voucher-codes/:eventid',
      name: 'ManageVoucherCodes',
      component: () =>
        import(
          /* webpackChunkName: "ManageVoucherCodes" */ './views/ManageVoucherCodes.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },

    // {
    //   path: '/heats/:eventid',
    //   name: 'ManageHeatsv2',
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "ManageHeatsv2" */ './views/ManageHeatsv2.vue'
    //     ),
    //   meta: {
    //     authenticated: true,
    //     quicklinks: true
    //   }
    // },
    {
      path: '/heats/:eventid/newworkout',
      name: 'AddHeatWorkout',
      component: () =>
        import(
          /* webpackChunkName: "ManageHeatsWorkout" */ './views/ManageHeatsWorkout.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/heats/:eventid/:workoutid',
      name: 'ManageHeatsWorkout',
      component: () =>
        import(
          /* webpackChunkName: "ManageHeatsWorkout" */ './views/ManageHeatsWorkout.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/dashboard/:eventid',
      name: 'EventDashboard',
      component: () =>
        import(
          /* webpackChunkName: "EventDashboard" */ './views/EventDashboard.vue'
        ),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid',
      name: 'EditEvent',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEvent.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/basicinfo',
      name: 'EditEventBasicInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventBasicInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/dateinfo',
      name: 'EditEventDateInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventDateInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/addressinfo',
      name: 'EditEventAddressInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventAddressInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/entrycapinfo',
      name: 'EditEventEntryCapInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventEntryCapInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/teaminfo',
      name: 'EditEventTeamInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventTeamInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/entryfeeinfo',
      name: 'EditEventEntryFeeInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventEntryFeeInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/paymentinfo',
      name: 'EditEventPaymentInfo',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventPaymentInfo.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/registrationoptions',
      name: 'EditEventRegistrationOptions',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventRegistrationOptions.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event/:eventid/liveeventoptions',
      name: 'EditEventLiveEventOptions',
      component: () =>
        import(/* webpackChunkName: "EditEvent" */ './views/EditEventLiveEventOptions.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/event-options/:eventid',
      name: 'EditEventOptions',
      component: () =>
        import(/* webpackChunkName: "EditEventOptions" */ './views/EditEventOptions.vue'),
      meta: {
        authenticated: true,
        quicklinks: true
      }
    },
    {
      path: '/manage-admins',
      name: 'ManageAdmins',
      component: () =>
        import(
          /* webpackChunkName: "ManageAdmins" */ './views/ManageAdmins.vue'
        ),
      meta: {
        superadmin: true,
        authenticated: true
      }
    },
    {
      path: '/*',
      component: () =>
        import(/* webpackChunkName: "NotFound" */ './views/NotFound.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
